/* eslint-disable import/extensions */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
import React, { ReactElement, ReactChild } from "react";
import { Dialog } from "@reach/dialog";
import { VisuallyHidden } from "@reach/visually-hidden";
import styled from "styled-components";
import SVG from "react-inlinesvg";
import "@reach/dialog/styles.css";
import { redesignTheme } from "../theme/theme";

type ModalProps = {
  ariaLabel: string;
  children: ReactChild;
  close: () => void;
  showDialog: boolean;
  testId?: string;
  title?: ReactChild;
  style?: React.CSSProperties;
};

const StyledModal = styled(Dialog)`
  &&& {
    background: ${redesignTheme.color.white};
    border-radius: ${redesignTheme.radius.lg};
    padding: 0;
    display: flex;
    flex-direction: column;
    position: relative;
    font-weight: ${redesignTheme.fontWeight.normal};
    font-family: ${redesignTheme.fontFamily.interface};
    }
    color: ${redesignTheme.color.gray900};
    max-width: 480px;
  }
`;

// just in case we need to tweak the modal in the future. Can delete after specific modal is built
const StyledContent = styled.div``;

const StyledCloseButton = styled.button`
  outline: none;
  position: absolute;
  border: none;
  top: 14px;
  right: 14px;
  background: transparent;
  &:hover {
    cursor: pointer;
  }
`;

const StyledTitle = styled.h3`
  font-size: ${redesignTheme.fontSize[300]};
  margin: 18px 0 18px 20px;
  font-weight: ${redesignTheme.fontWeight.semibold};
  font-family: ${redesignTheme.fontFamily.interface};
`;

const StyledSpan = styled.span`
  display: inline-block;
  margin-top: ${redesignTheme.spacing[1]};
`;

const ReactModal = ({
  ariaLabel,
  children,
  close,
  showDialog,
  testId,
  title,
  style = {},
}: ModalProps): ReactElement => {
  const closeSvg = require("../svg/closeGreyBackground.svg");
  return (
    <StyledModal
      aria-label={ariaLabel}
      data-testid={testId}
      isOpen={showDialog}
      onDismiss={close}
      style={style}
    >
      <StyledCloseButton type="button" onClick={close}>
        <VisuallyHidden>Close</VisuallyHidden>
        <StyledSpan aria-hidden>
          <SVG src={closeSvg} />
        </StyledSpan>
      </StyledCloseButton>
      <StyledContent>
        {title && <StyledTitle data-testid="modal-title">{title}</StyledTitle>}
        {children}
      </StyledContent>
    </StyledModal>
  );
};

ReactModal.defaultProps = {
  testId: "",
  title: "",
  style: {},
};

export default ReactModal;
